import { api } from '@/api'
import {
  FavoritesRes,
  FavoritesSmallRes,
} from '@/modules/favorites/types/favorites'
import { ISimpleResponse } from '@/modules/login/types'

export type UpdateFavoriteDeviceBody = {
  deviceId: number
  favoriteIds: number[]
}

export type UpdateFavoritesBody = {
  data: string
}

const favoritesOrganismApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchFavoritesList: build.query<FavoritesSmallRes, void>({
      query: () => ({
        url: '/favorites/get',
        method: 'GET',
      }),
      providesTags: ['FavoritesSmall'],
    }),
    fetchFavoritesWithDevices: build.query<FavoritesRes, void>({
      query: () => ({
        url: '/favorites/getWithDevices',
        method: 'GET',
      }),
      providesTags: ['Favorites'],
    }),
    updateFavoriteDevice: build.mutation<
      ISimpleResponse,
      UpdateFavoriteDeviceBody
    >({
      query: (body) => ({
        url: '/favorites/updateDevice',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Favorites', 'FavoritesSmall', 'Device'],
    }),
    updateFavorites: build.mutation<ISimpleResponse, UpdateFavoritesBody>({
      query: (body) => ({
        url: '/favorites/update',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['FavoritesSmall', 'Favorites'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchFavoritesListQuery,
  useFetchFavoritesWithDevicesQuery,
  useUpdateFavoriteDeviceMutation,
  useUpdateFavoritesMutation,
} = favoritesOrganismApi
